<template>
  <div class="dashboard__ttlspending" style="min-height: 110px;">
    <div class="p-5 d-flex justify-content-center align-items-center"
      v-if="isLoading">
      <half-circle-spinner
        :animation-duration="1500"
        :size="25"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else class="d-flex">
      <div class="dashboard__ttlspending--content" v-if="datas.body && datas.body.length > 1" v-b-toggle="getTotal != '-' ? 'collapse-1': ''" style="width: 100%;">
        <div class="d-flex">
          <div class="mr-2">
            <img :src="datas.img" alt="">
          </div>
          <div style="width: 100%;">
            <div class="fontstyle__title--sectionblue" style="color: #FD9E00;">{{ datas.header }}</div>
            <div class="d-flex justify-content-between  m-0 content__body--ttlspending">
              <div class="pr-0 mr-2 ttlspending__number d-flex justify-content-between">
                <p v-if="datas.body.length > 1">{{getTotal}}</p>
                <p v-else>-</p>
              </div>
              <img v-if="getTotal != '-'" style="width: 18px;" src="@/assets/image/icon/Down.svg" alt="">
              <img v-else style="width: 18px;" src="@/assets/image/icon/Down-grey.svg" alt="">
            </div>
          </div>
        </div>
        <b-collapse id="collapse-1" class="mt-2">
          <div class="d-flex mb-2">
            <div class="mr-4">
              <img :src="datas.air" alt="">
            </div>
            <div style="width: 100%;">
              <div class="fontstyle__title--sectionblue">{{datas.body[0].title}}</div>
              <div class="row m-0 content__body--ttlspending">
                <div class="pr-0 ttlspending__number">
                  <p>{{datas.body[0].total}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="mr-4">
              <img :src="datas.ocean" alt="">
            </div>
            <div style="width: 100%;">
              <div class="fontstyle__title--sectionblue">{{datas.body[1].title}}</div>
              <div class="row m-0 content__body--ttlspending">
                <div class="pr-0 ttlspending__number">
                  <p>{{datas.body[1].total}}</p>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="dashboard__ttlspending--content d-flex" style="width: 100%;" v-else>
        <div class="mr-4">
          <img :src="datas.img" alt="">
        </div>
        <div style="width: 100%;">
          <div class="fontstyle__title--sectionblue" :style="datas.style">{{ datas.header }}</div>
          <div class="row m-0 content__body--ttlspending">
            <div class="pr-0 ttlspending__number">
              <p>{{datas.total || '-'}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
const AIR = 'Air'
const OCEAN = 'Ocean'
export default {
  name: 'TotalSpending',
  props: {
    datas: Object,
    isLoading: Boolean
  },
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      AIR,
      OCEAN
    }
  },
  computed: {
    getTotal () {
      if (this.datas.body.length > 1) {
        let air = parseFloat(this.datas.body[0].total.replace(/,/g, ''))
        const ocean = parseFloat(this.datas.body[1].total.replace(/,/g, ''))
        if (air + ocean > 0) {
          return (air + ocean).toLocaleString()
        } else {
          return '-'
        }
      } else {
        return this.datas.body[0].total
      }
    }
  },
  methods: {
    getIcon (item) {
      if (item === AIR) {
        return require('@/assets/image/icon/icon_air.svg')
      } else if (item === OCEAN) {
        return require('@/assets/image/icon/icon_ocean.svg')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/TotalSpending.vue